import React from "react";
import { article } from "@Api";
import ArticleItem from "./item";
import styles from "./index.module.less";

const { fetchV3Articles } = article;

class ArticleList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      left: true,
      right: false,
    };
  }
  targetRef = React.createRef();
  componentDidMount() {
    const { info } = this.props;
    info.data.kind_id !== "0" && this.getList();
    setTimeout(() => {
      this.targetRef.current && this.targetRef.current.addEventListener("scroll", (e) => this.onScroll(e));
    }, 800);
  }

  componentWillUnmount() {
    this.targetRef.current && this.targetRef.current.removeEventListener("scroll", (e) => this.onScroll(e));
  }

  async getList() {
    const { request, params } = this.props;
    const res = await request(params);

    if (res && res.status === 12000) {
      this.setState({
        data: res.data.list,
      });
    }
  }

  scrollTo = (scrollValue) => {
    if (this.targetRef.current) {
      let scrollLeft = this.targetRef.current.scrollLeft;
      this.targetRef.current.scrollTo(scrollLeft + scrollValue, 0);
    }
  };

  onScroll = (e) => {
    if (this.targetRef.current && e) {
      const element = e.currentTarget;
      const scrollLeft = element.scrollLeft;
      const scrollWidth = element.scrollWidth;
      const clientWidth = element.clientWidth;

      const scrollRight = scrollWidth - clientWidth;
      this.setState({
        right: scrollLeft >= scrollRight,
        left: scrollLeft === 0,
      });
    }
  };

  render() {
    const { category, info } = this.props;
    const { data, left, right } = this.state;

    if (((info?.completeKinds || []).length === 0 || (info?.kinds || []).length === 0) && data.length === 0) {
      return null;
    }

    return (
      <section className={styles["ArticleList"]}>
        <h2>相關文章</h2>
        <div className={styles["content"]}>
          <div className={styles["brand-scroll"]} ref={this.targetRef}>
            {!right && data.length > 4 && <i className={styles["right-icon"]} onClick={() => this.scrollTo(970)} />}
            {!left && <i className={styles["left-icon"]} onClick={() => this.scrollTo(-970)} />}

            {Array.isArray(data) && data.map((v, i) => <ArticleItem data={v} key={i} category={category} />)}
          </div>
        </div>
      </section>
    );
  }
}

export default ArticleList;
